import Vue from "vue"
import Router, { Route } from "vue-router"
import store from "../store/index"
// import LoginPage from "@/components/Signup/Login";
// import PatientFav from "@/components/Users/Patient/PatientFavorites";
// import AdvocateUpdates from "@/components/Users/Advocate/AdvocateUpdates";
// import AdvocateFav from "@/components/Users/Advocate/AdvocateFavorites";
// import AdvocateQA from "@/components/Users/Advocate/QA/AdvocateQA";
// import CaregiverProfile from '@/components/Users/Caregiver/CaregiverProfile'
// import CaregiverUpdates from '@/components/Users/Caregiver/CaregiverUpdates'
// import CaregiverAbout from '@/components/Users/Caregiver/CaregiverAbout'
// import MeetProviders from "@/components/home/meetothers/MeetProviders";
// import ViewDoctorUpdates from "../components/Users/Doctor/view/ViewDoctorUpdates";
// import ViewDoctorFav from "../components/Users/Doctor/view/ViewDoctorFavorites";
// import OtherHealthProfesionalsList from "@/components/home/otherProfesionals/OtherProfesionalsList";
// import Article from '@/components/home/resources/contents/Article'
// import ViewDoctorProfileReviews from "../components/Users/Doctor/view/ViewDoctorProfileReviews";
// import ViewNfpAbout from "../components/Users/Doctor/view/ViewNfpAbout.vue"
// import CaregiverCircles from '@/components/Users/Caregiver/CaregiverCircles'
// import CaregiverQA from '@/components/Users/Caregiver/QA/CaregiverQA'
// import CaregiverFav from '@/components/Users/Caregiver/CaregiverFavorites'
// import CaregiverTreatments from '@/components/Users/Caregiver/CaregiverTreatments'
// import Profile from '../components/App/Profile'
// import DocUpdates from "../components/Users/Doctor/DoctorUpdates";
// import hospitalAbout from "../components/Users/Doctor/hospitalAbout"
// import viewNfpAbout from "../components/Users/Doctor/view/viewNfpAbout.vue"
// import DocReview from "../components/Users/Doctor/DoctorReviews";
// import DocPolls from "../components/Users/Doctor/DoctorPolls";
// import CreateMessageModal from "../components/Modals/CreateMessageModal.vue";
// import CreatePollModal from "../components/Modals/CreatePollModal.vue";
// import CreateQuestionModal from "../components/Modals/CreateQuestionModal.vue";
import SignupLayout from "@/components/Signup/SignupLayout"
import UserType from "@/components/Signup/SignupUserType"
import UserName from "@/components/Signup/SignupUserName"
import ClaimProfile from "@/components/Signup/ClaimProfile"
import DoctorProfile from "@/components/Signup/DoctorProfile"
import UserProfileLayout from "@/components/Signup/UserProfile/UserProfileLayout"
import UserProfileWelcome from "@/components/Signup/UserProfile/Welcome"
import UserProfileWelcomeAdvocate from "@/components/Signup/UserProfile/WelcomeAdvocate"
import WelcomeAdmin from "@/components/Signup/UserProfile/WelcomeAdmin"
import LoginAdmin from "@/components/Signup/UserProfile/LoginAdmin"
import LoginAdminSelect from "@/components/Signup/UserProfile/LoginAdminSelect"
import UserSymptoms from "@/components/Signup/UserProfile/Symptoms"
import UserTreatments from "@/components/Signup/UserProfile/Treatments"
import UserYourStory from "@/components/Signup/UserProfile/YourStory"
import SignupPage from "@/components/Signup/Signup"
import Home from "@/components/App/Home"
import SupportPage from "@/components/App/Support"
import OtherSymptomsSignup from "../components/Signup/UserProfile/otherSymptoms.vue"
import DocProfile from "../components/Users/Doctor/DoctorProfile"
import DocAbout from "../components/Users/Doctor/DoctorAbout"
import HospitalAbout from "../components/Users/Doctor/hospitalAbout"
import DocFav from "../components/Users/Doctor/DoctorFavorites"
import DocCircles from "../components/Users/Doctor/DoctorCircles"
import OHCP from "../components/Users/Doctor/OHCP.vue"
import NFP_PROFILE from "../components/Users/Doctor/NFP_Profile.vue"
import ClinicProfile from "../components/Users/Doctor/ClinicProfile.vue"
import ViewClinicAbout from "../components/Users/Doctor/view/ClinicAbout.vue"
import ViewHospitalAbout from "../components/Users/Doctor/view/HospitalAbout.vue"
import PatientMutedUser from "../components/Users/Patient/PatientMutedUser"
import PatientProfile from "@/components/Users/Patient/PatientProfile"
import PatientUpdates from "@/components/Users/Patient/PatientUpdates"
import PatientAbout from "@/components/Users/Patient/PatientAbout"
import PatientCircles from "@/components/Users/Patient/PatientCircles"
import PatientQA from "@/components/Users/Patient/QA/PatientQA"
import PatientProfileReview from "@/components/Users/Patient/PatientProfileReview"
import PatientMedReview from "@/components/Users/Patient/PatientMedReview"
import PatientProfileRec from "@/components/Users/Patient/PatientProfileRec"
import PatientTreatmentRec from "@/components/Users/Patient/PatientTreatmentRec"
import PatientTreatments from "@/components/Users/Patient/PatientTreatments"
import AdvocateProfile from "@/components/Users/Advocate/AdvocateProfile"
import AdvocateAbout from "@/components/Users/Advocate/AdvocateAbout"
import AdvocateCircles from "@/components/Users/Advocate/AdvocateCircles"
import AppLayout from "@/components/App/AppLayout"
import ProfileLayout from "@/components/App/ProfileLayout"
import CircleLayout from "@/components/App/CircleLayout"
import LoginRolePage from "@/components/account/LoginRolePage"
import AllCircles from "@/components/App/circle/AllCircles"
import MyCircles from "@/components/App/circle/MyCircles"
import PatientCirlceSelf from "@/components/commons/profile/circle/SelfCircleMembers"
import PatientCircleOther from "@/components/commons/profile/circle/OtherCircleMembers"
import PatientCircleProviders from "@/components/commons/profile/circle/SelfProviders"
import Activity from "@/components/home/Activity"
import MeetOthers from "@/components/home/MeetOthers"
import MeetPeople from "@/components/home/meetothers/MeetPeople"
import AboutCircle from "@/components/home/aboutCircle/AboutCircle"
import AboutCircleLayout from "@/components/home/aboutCircle/AboutCircleLayout"
import LeaveCircle from "@/components/home/aboutCircle/LeaveCircle"
import ReviewsLayout from "@/components/home/reviews/ReviewsLayout"
import Reviews from "@/components/home/reviews/Reviews"
import IndividualReviews from "@/components/home/reviews/IndividualReviews"
import ProfileReceivedReviews from "@/components/home/reviews/ProfileReceivedReviews"
import OtherCircles from "@/components/home/OtherCircles"
import QA from "@/components/home/QA/QA"
import QASearch from "@/components/home/QA/SearchQA"
import QAAskQuestion from "@/components/home/QA/AskQuestion"
import MedicalDirectories from "@/components/home/MedicalDirectories/MedicalDirectory.vue"
import MainMedicalDirectories from "@/components/home/MedicalDirectories/MainMedicalDirectory.vue"
import MyDoveDirectory from "@/components/home/MyDoveDirectory"
import MyDoveDirectoryPage from "@/components/home/MyDoveDirectoryPage"
import MyDoveDirectoryFilterPage from "@/components/home/MyDoveDirectoryFilterPage"
import ProviderDirectory from "@/components/home/ProviderDirectory"
import NFPDirectory from "@/components/home/NFPDirectory"
import BusinessDirectory from "@/components/home/BuisnessDirect.vue"
import HospitalDirectory from "@/components/home/HospitalDirectory"
import ClinicDirectory from "@/components/home/ClinicDirectory"
import OtherHealthProfesionals from "@/components/home/OtherHealthProfesionals"
import OtherHealthProfesionalsView from "@/components/home/otherProfesionals/OtherProfesionalsView"
import Resources from "@/components/home/Resources"
import ResourceList from "@/components/home/resources/ResourceList"
import ResourceView from "@/components/home/resources/ResourceView"
import Quizzes from "@/components/home/quiz/Quizzes"
import Treatments from "@/components/home/Treatments"
import Notification from "@/components/App/Notification"
import Account from "@/components/account/Account"
import YourActivity from "@/components/account/YourActivity"
import AccountSettings from "@/components/account/AccountSettings"
import NotificationSettings from "@/components/account/NotificationSettings"
import Treatment from "@/components/home/treatments/Treatment"
import ViewProfileLayout from "@/components/App/ViewProfileLayout"
import ViewPatientProfile from "@/components/Users/Patient/view/ViewPatientProfile"
import ViewPatientUpdates from "@/components/Users/Patient/view/ViewPatientUpdates"
import ViewPatientAbout from "@/components/Users/Patient/view/ViewPatientAbout"
import ViewPatientCircles from "@/components/Users/Patient/view/ViewPatientCircles"
import ViewPatientQA from "@/components/Users/Patient/view/QA/PatientQA"
import ViewPatientFavorites from "@/components/Users/Patient/view/ViewPatientFavorites"
import ViewPatientDoveDaily from "@/components/Users/Patient/view/ViewPatientDoveDaily"
import ViewPatientTreatments from "@/components/Users/Patient/view/ViewPatientTreatments"
import ViewPatientMedReview from "@/components/Users/Patient/view/ViewPatientMedReview"
import ViewPatientTreatmentRec from "@/components/Users/Patient/view/ViewPatientTreatmentRec"
import ViewDoctorProfile from "../components/Users/Doctor/view/ViewDoctorProfile"
import HospitalViewProfile from "../components/Users/Doctor/view/ViewHospitalProfile"
import ViewDoctorAbout from "../components/Users/Doctor/view/ViewDoctorAbout"
import OhcpAboutView from "../components/Users/Doctor/view/OhcpAboutView"
import ViewDoctorCircles from "../components/Users/Doctor/view/ViewDoctorCircles"
import ViewDoctorProfilePolls from "../components/Users/Doctor/view/ViewDoctorProfilePolls"
import ViewAdvocateProfile from "@/components/Users/Advocate/view/ViewAdvocateProfile"
import ViewAdvocateAbout from "@/components/Users/Advocate/view/ViewAdvocateAbout"
import ViewAdvocateCircles from "@/components/Users/Advocate/view/ViewAdvocateCircles"
import ViewCirlceSelf from "@/components/commons/profile/circle/view/SelfCircleMembers"
import ViewCircleOther from "@/components/commons/profile/circle/view/OtherCircleMembers"
import ViewCircleProviders from "@/components/commons/profile/circle/view/SelfProviders"
import ViewCircleMembersAll from "../components/commons/profile/circle/view/viewSelfCircleMembersAll.vue"
import AllCircleMembers from "../components/commons/profile/circle/SelfCircleMembersAll.vue"
import ViewNfpProfile from "../components/Users/Doctor/view/ViewNfpProfile.vue"
import viewNfpAbout from "../components/Users/Doctor/view/ViewNfpAbout"
import ContactUsPage from "@/components/App/ContactUs"
import CircleDescription from "../components/App/CircleDescriptionPage.vue"
import Share from "@/components/commons/Share"
import ShareQuestion from "../components/commons/ShareQUestion.vue"
import EmailVerify from "@/components/home/EmailVerification"
import SSOOauth from "@/components/login/oauth"
import SearchCircle from "../components/App/circle/searchCircle.vue"
import CrisisHelpline from "../components/App/CrisisHelpline.vue"
import PathNotFound from "../components/404.vue"
import PatientDovedaily from "../components/Users/Patient/PatientDovedaily.vue"
import PatientPolls from "../components/Users/Patient/PatientPolls.vue"
import PatientSaved from "../components/Users/Patient/PatientSaved.vue"
import PatientReviews from "../components/Users/Patient/PatientReviews.vue"
import SearchPage from "../components/App/circle/SearchPage.vue"
import JoinedCircle from "../components/App/circle/JoinedCircle.vue"
import CircleSearch from "../components/App/circle/CircleSearch.vue"
import DefaultCircle from "../components/App/circle/DefaultCircle.vue"
import UnAuthCircle from "../components/App/circle/UnAuthCircle.vue"
import Settings from "../components/App/circle/Settings.vue"
import CirclesAll from "../components/App/circle/CirclesAll.vue"
import meetAdvocates from "../components/home/meetAdvocates.vue"
import DoveMedRecommmended from "../components/home/DoveMedRecommended.vue"
import DoveMedRecommmendedPage from "../components/home/DoveMedRecommendedPage.vue"
import DoveMedRecommmendedFilter from "../components/home/DoveMedRecommendedFilter.vue"
import Recommended from "../components/home/Recommended/Recommended.vue"
import IndividualRecommend from "../components/home/Recommended/IndividualRecommend.vue"
import RecommmendLayout from "../components/home/Recommended/RecommendLayout.vue"
import MyCircleStats from "../components/home/MyCircleStats.vue"
import UpdateDoveDaily from "../components/home/UpdateDoveDaily.vue"

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return new Promise((resolve, reject) => {
    originalPush.call(
      this,
      location,
      () => {
        // on complete
        resolve(this.currentRoute)
      },
      error => {
        // on abort
        // only ignore NavigationDuplicated error
        if (error.name === "NavigationDuplicated") {
          resolve(this.currentRoute)
        } else {
          reject(error)
        }
      }
    )
  })
}

const scrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) {
    return savedPosition
  } else {
    // console.log(from,'- Scrolling -',to);
    if (from.path.includes("profile") && to.path.includes("profile")) {
      return
    } else {
      document.body.scrollTop = 0
    }
  }
}

export default new Router({
  scrollBehavior,
  mode: "history",

  base: `/${process.env.PUBLIC_PATH}/`,
  routes: [
    {
      name: "SSO-Oauth-Callback",
      path: "/sso-oauth-callback",
      component: SSOOauth,
      beforeEnter(to, from, next) {
        if (to.matched.some(record => !record.meta.requiresAuth)) {
          const user = store.getters["User/user"]
          if (user) {
            next("/circles/all") // To activate mycircles again, route to /circles/mycircles
            return
          }
          next()
        } else {
          next()
        }
      },
      meta: {
        requiresAuth: false,
      },
    },

    // {
    //   name: "Login",
    //   path: "/login",
    //   component: LoginPage

    // },
    // Email verification route
    {
      name: "Signup",
      pathMatch: "full",
      path: "/signup",
      component: SignupPage,
      meta: {
        requiresAuth: false,
      },
    },
    {
      name: "EmailVerify",
      path: "/verify",
      component: EmailVerify,
    },
    {
      name: "ContactUs",
      path: "/contact-us",
      component: ContactUsPage,
      meta: {
        requiresAuth: false,
      },
    },
    {
      name: "CrisisHelpline",
      path: "/Help-line",
      component: CrisisHelpline,
    },
    {
      path: "/searchpage",
      component: SearchPage,
      children: [
        { path: "", pathMatch: "full", redirect: "unauthcircle" },
        {
          path: "default",
          name: "DefaultCircle",
          component: DefaultCircle,
          children: [
            {
              path: "search",
              name: "CircleSearch",
              component: CircleSearch,
            },
            {
              path: "all",
              name: "CirclesAll",
              component: CirclesAll,
            },
          ],
        },
        {
          path: "unauthcircle",
          name: "UnAuthCircle",
          component: UnAuthCircle,
          beforeEnter: (to, from, next) => {
            const user = store.getters["User/user"]
            if (user) {
              next("/searchpage/joinedcircle")
              return
            }
            next()
          },
        },
        {
          path: "joinedcircle",
          name: "JoinedCircle",
          component: JoinedCircle,
          beforeEnter: (to, from, next) => {
            const user = store.getters["User/user"]
            if (!user) {
              next("/searchpage/unauthcircle")
              return
            }
            next()
          },
        },
        {
          path: "settings",
          name: "Settings",
          component: Settings,
        },
      ],
    },
    {
      path: "",
      pathMatch: "full",
      redirect: "/circles/all",
    },
    {
      path: "/circles",
      component: CircleLayout,
      children: [
        { path: "", pathMatch: "full", redirect: "all" },
        { path: "all", name: "AllCircles", component: AllCircles },
        {
          path: "all/:search/:type",
          name: "searchCircle",
          component: SearchCircle,
        },
        {
          path: "mycircles",
          name: "MyCircles",
          component: MyCircles,
          beforeEnter: (to, from, next) => {
            const user = store.getters["User/user"]
            if (!user) {
              next("/circles")
              return
            }
            next()
          },
        },
      ],
    },
    {
      path: "/:circle/signup",
      component: SignupLayout,
      children: [
        { path: "", name: "UserType", component: UserType },
        { path: "username", name: "UserName", component: UserName },
        { path: "claimProfile", name: "ClaimProfile", component: ClaimProfile },
        {
          path: "doctorProfile",
          name: "SignupDoctorProfile",
          component: DoctorProfile,
        },
        {
          path: "circleInfo",
          name: "CircleDescription",
          component: CircleDescription,
          // beforeEnter: (to, from, next) => {
          //   window.scrollTo(0, 0);
          //   const user = store.getters["User/user"];
          //   if (!user) {
          //     next("/circles");
          //     return;
          //   }
          //   next();
          // }
        },
        {
          path: "userProfile",
          component: UserProfileLayout,
          children: [
            {
              path: "welcome",
              name: "UserProfileWelcome",
              component: UserProfileWelcome,
            },
            {
              path: "welcomeAdvocate",
              name: "UserProfileWelcomeAdvocate",
              component: UserProfileWelcomeAdvocate,
            },

            { path: "symptoms", name: "UserSymptoms", component: UserSymptoms },

            {
              path: "other_symptoms",
              name: "OtherSymptonsSignup",
              component: OtherSymptomsSignup,
            },
            {
              path: "treatments",
              name: "UserTreatments",
              component: UserTreatments,
            },

            {
              path: "yourStory",
              name: "UserYourStory",
              component: UserYourStory,
            },
            {
              path: "administrator",
              name: "WelcomeAdmin",
              component: WelcomeAdmin,
            },
            {
              path: "administratorlogin",
              name: "LoginAdmin",
              component: LoginAdmin,
            },
            {
              path: "administratorselect",
              name: "LoginAdminSelect",
              component: LoginAdminSelect,
            },
          ],
          beforeEnter: (to, from, next) => {
            window.scrollTo(0, 0)
            console.log("Scrolling...")
            const user = store.getters["User/user"]
            if (!user) {
              next("/circles")
              return
            }
            next()
          },
        },
      ],
    },

    {
      path: "/:circle",
      name: "App",
      component: AppLayout,
      children: [
        { path: "", redirect: "home" },

        {
          path: "/:circles/select-profile",
          name: "ProfileSelect",
          component: LoginRolePage,
        },
        {
          path: "notifications",
          name: "Notification",
          component: Notification,
        },
        {
          path: "update-dovedaily",
          name: "UpdateDoveDaily",
          component: UpdateDoveDaily,
        },
        {
          path: "support",
          name: "Support",
          component: SupportPage,
        },
        {
          path: "home",
          name: "Home",
          component: Home,
          children: [
            {
              path: "activity/:type?",
              name: "ActivityHome",
              component: Activity,
              // children: [
              //   {
              //     path: "createmessage",
              //     name: "createMessageModal",
              //     component: CreateMessageModal
              //   },
              //   {
              //     path: "createpoll",
              //     name: "createPollModal",
              //     component: CreatePollModal
              //   },
              //   {
              //     path: "createquestion",
              //     name: "createQuestionModal",
              //     component: CreateQuestionModal
              //   }
              // ]
            },
            {
              path: "view/:type/:id/:cmnttype?/:cmntid?",
              name: "NotificationView",
              component: Share,
            },
            {
              path: "qa/share/:id?",
              name: "ShowSharedQuestion",
              component: ShareQuestion,
            },
            {
              path: "meetothers",
              name: "MeetOthers",
              component: MeetOthers,
              children: [
                { path: "people", name: "MeetPeople", component: MeetPeople },
                // {
                //   path: "providers",
                //   name: "MeetProviders",
                //   component: MeetProviders
                // }
              ],
            },
            {
              path: "dovemedrecommended",
              name: "DoveMedRecommended",
              component: DoveMedRecommmended,
              children: [
                {
                  path: "",
                  name: "DoveMedRecommendedPage",
                  component: DoveMedRecommmendedPage,
                },
                {
                  path: "filter",
                  name: "DoveMedRecommendedFilter",
                  component: DoveMedRecommmendedFilter,
                },
              ],
            },
            {
              path: "recommendations",
              component: RecommmendLayout,
              children: [
                { path: "", name: "Recommended", component: Recommended },
                {
                  path: ":id",
                  name: "IndividualRecommend",
                  component: IndividualRecommend,
                },
              ],
            },
            {
              path: "mycirclestats",
              name: "MyCircleStats",
              component: MyCircleStats,
            },
            {
              path: "aboutcircle",
              component: AboutCircleLayout,
              children: [
                { path: "", name: "AboutCircle", component: AboutCircle },
                { path: "leavecircle", name: "LeaveCircle", component: LeaveCircle },
              ],
            },
            {
              path: "reviews",
              component: ReviewsLayout,
              children: [
                { path: "", name: "Reviews", component: Reviews },
                { path: ":type/:id", name: "IndividualReviews", component: IndividualReviews },
              ],
            },
            {
              path: "othercircles",
              name: "OtherCircles",
              component: OtherCircles,
            },
            {
              path: "provider_directory",
              name: "ProviderDirectory",
              component: ProviderDirectory,
            },
            {
              path: "hospital_directory",
              name: "HospitalDirectory",
              component: HospitalDirectory,
            },
            {
              path: "clinic_directory",
              name: "ClinicDirectory",
              component: ClinicDirectory,
            },
            {
              path: "nfp_directory",
              name: "NFPDirectory",
              component: NFPDirectory,
            },
            {
              path: "other_health_profesionals",
              component: OtherHealthProfesionals,
              children: [
                // {
                //   path: "",
                //   name: "OtherHealthProfesionalsList",
                //   component: OtherHealthProfesionalsList
                // },
                {
                  path: "",
                  name: "OtherHealthProfesionalsList",
                  component: OtherHealthProfesionalsView,
                },
              ],
            },
            {
              path: "qa",
              name: "QA",
              component: QA,
              redirect: { name: "QASearch" },
              children: [
                { path: "search", name: "QASearch", component: QASearch },
                {
                  path: "askquestion",
                  name: "QAAskQuestion",
                  component: QAAskQuestion,
                },
              ],
            },
            {
              path: "resources",
              component: Resources,
              children: [
                { path: "", name: "ResourceList", component: ResourceList },
                // {
                //   path: ":type/:id",
                //   name: "ResourceView",
                //   component: ResourceView
                // },
                { path: "quizzes", name: "Quizzes", component: Quizzes },
              ],
            },
            {
              path: "treatments",
              name: "Treatments",
              component: Treatments,
              // children: [{path: ":type/:id", name: "Treatment", component: Treatment}]
            },
            {
              path: "meetAdvocates",
              name: "meetAdvocates",
              component: meetAdvocates,
            },
            {
              path: "treatments/:type/:id",
              name: "Treatment",
              component: Treatment,
            },
            {
              path: "notificationsettings",
              name: "NotificationSettings",
              component: NotificationSettings,
            },
            {
              path: "medicaldirectories",
              component: MainMedicalDirectories,
              children: [
                {
                  path: "",
                  name: "MedicalDirectory",
                  component: MedicalDirectories,
                },
                {
                  path: "physicians",
                  name: "ProviderSearch",
                  component: ProviderDirectory,
                },
                {
                  path: "practiceproviders",
                  name: "PracticeSearch",
                  component: OtherHealthProfesionalsView,
                },
                {
                  path: "hospitals",
                  name: "HospitalSearch",
                  component: HospitalDirectory,
                },
                {
                  path: "clinics",
                  name: "ClinicSearch",
                  component: ClinicDirectory,
                },
                {
                  path: "nfps",
                  name: "NFPSearch",
                  component: NFPDirectory,
                },
                {
                  path: "business",
                  name: "BusinessDirectory",
                  component: BusinessDirectory,
                },
              ],
            },
            {
              path: "mydovedirectory",
              component: MyDoveDirectoryPage,
              children: [
                {
                  path: "",
                  name: "MyDoveDirectory",
                  component: MyDoveDirectory,
                },
                {
                  path: ":role",
                  name: "DoveDirectoryfilterpage",
                  component: MyDoveDirectoryFilterPage,
                },
              ],
            },
          ],
        },
        {
          path: "/:type/:id",
          name: "ResourceView",
          component: ResourceView,
        },
        {
          path: "profile",
          component: ProfileLayout,
          children: [
            {
              path: "doctor",
              name: "DocProfile",
              component: DocProfile,
              children: [
                { path: "updates", name: "DocUpdates", component: PatientUpdates },
                { path: "about", name: "DocAbout", component: DocAbout },
                { path: "dovedaily", name: "DocDoveDaily", component: PatientDovedaily },
                {
                  path: "circles",
                  name: "DocCircles",
                  component: DocCircles,
                  children: [
                    {
                      path: "allCircleMembers",
                      name: "allSelfDoctorCircleMembers",
                      component: AllCircleMembers,
                    },
                    {
                      path: "self",
                      name: "doctorCirlceSelf",
                      component: PatientCirlceSelf,
                    },
                    {
                      path: "other",
                      name: "doctorCircleOther",
                      component: PatientCircleOther,
                    },
                    {
                      path: "providers",
                      name: "doctorCircleProviders",
                      component: PatientCircleProviders,
                    },
                    {
                      path: "hospitals",
                      name: "doctorCircleHospitals",
                      component: PatientCircleProviders,
                    },
                    {
                      path: "clinics",
                      name: "doctorCircleClinics",
                      component: PatientCircleProviders,
                    },
                    {
                      path: "nfp",
                      name: "doctorCircleNfp",
                      component: PatientCircleProviders,
                    },
                    {
                      path: "hcp",
                      name: "doctorCircleHcp",
                      component: PatientCircleProviders,
                    },
                  ],
                },
                { path: "qa", name: "DocQA", component: PatientQA },
                { path: "saved", name: "DocFav", component: PatientSaved },
                { path: "polls", name: "DocPolls", component: PatientPolls },
                { path: "profilerev", name: "DoctorProfileReview", component: PatientProfileReview },
                { path: "medrev", name: "DoctorMedReview", component: PatientMedReview },
                { path: "profilercmnd", name: "DoctorProfileRec", component: PatientProfileRec },
                { path: "treatmentrcmnd", name: "DoctorTreatmentRec", component: PatientTreatmentRec },
                { path: "muteduser", name: "DoctorMutedUser", component: PatientMutedUser },
                { path: "receivedreviews/:type?", name: "ReceivedReviews", component: ProfileReceivedReviews },
              ],
            },
            {
              path: "hospital_administrator",
              name: "HosProfile",
              component: DocProfile,
              children: [
                { path: "updates", name: "HosUpdates", component: PatientUpdates },
                { path: "about", name: "HosAbout", component: HospitalAbout },
                { path: "dovedaily", name: "HosDoveDaily", component: PatientDovedaily },
                {
                  path: "circles",
                  name: "HosCircles",
                  component: DocCircles,
                  children: [
                    {
                      path: "allCircleMembers",
                      name: "allSelfHospitalCircleMembers",
                      component: AllCircleMembers,
                    },
                    {
                      path: "self",
                      name: "hospitalCirlceSelf",
                      component: PatientCirlceSelf,
                    },
                    {
                      path: "other",
                      name: "hospitalCircleOther",
                      component: PatientCircleOther,
                    },
                    {
                      path: "providers",
                      name: "hospitalCircleProviders",
                      component: PatientCircleProviders,
                    },
                    {
                      path: "hospitals",
                      name: "hospitalCircleHospitals",
                      component: PatientCircleProviders,
                    },
                    {
                      path: "clinics",
                      name: "hospitalCircleClinics",
                      component: PatientCircleProviders,
                    },
                    {
                      path: "nfp",
                      name: "hospitalCircleNfp",
                      component: PatientCircleProviders,
                    },
                    {
                      path: "hcp",
                      name: "hospitalCircleHcp",
                      component: PatientCircleProviders,
                    },
                  ],
                },
                { path: "qa", name: "HosQA", component: PatientQA },
                { path: "saved", name: "HosFav", component: PatientSaved },
                { path: "polls", name: "DocPolls", component: PatientPolls },
                { path: "profilerev", name: "Hospital_adminProfileReview", component: PatientProfileReview },
                { path: "medrev", name: "Hospital_adminMedReview", component: PatientMedReview },
                { path: "profilercmnd", name: "Hospital_adminProfileRec", component: PatientProfileRec },
                { path: "treatmentrcmnd", name: "Hospital_adminTreatmentRec", component: PatientTreatmentRec },
                { path: "muteduser", name: "Hospital_adminMutedUser", component: PatientMutedUser },
                { path: "receivedreviews/:type?", name: "ReceivedReviews", component: ProfileReceivedReviews },
              ],
            },
            {
              path: "hcp",
              name: "OHCP",
              component: DocProfile,
              children: [
                { path: "updates", name: "HcpUpdates", component: PatientUpdates },
                { path: "about", name: "HcpAbout", component: OHCP },
                { path: "dovedaily", name: "HcpDoveDaily", component: PatientDovedaily },
                {
                  path: "circles",
                  name: "HcpCircles",
                  component: DocCircles,
                  children: [
                    {
                      path: "allCircleMembers",
                      name: "allSelfHcpCircleMembers",
                      component: AllCircleMembers,
                    },
                    {
                      path: "self",
                      name: "HcpCirlceSelf",
                      component: PatientCirlceSelf,
                    },
                    {
                      path: "other",
                      name: "HcpCircleOther",
                      component: PatientCircleOther,
                    },
                    {
                      path: "providers",
                      name: "HcpCircleProviders",
                      component: PatientCircleProviders,
                    },
                    {
                      path: "hospitals",
                      name: "HcpCircleHospitals",
                      component: PatientCircleProviders,
                    },
                    {
                      path: "clinics",
                      name: "HcpCircleClinics",
                      component: PatientCircleProviders,
                    },
                    {
                      path: "nfp",
                      name: "HcpCircleNfp",
                      component: PatientCircleProviders,
                    },
                    {
                      path: "hcp",
                      name: "HcpCircleHcp",
                      component: PatientCircleProviders,
                    },
                  ],
                },
                { path: "qa", name: "HcpQA", component: PatientQA },
                { path: "saved", name: "HcpFav", component: PatientSaved },
                { path: "polls", name: "DocPolls", component: PatientPolls },
                { path: "profilerev", name: "HcpProfileReview", component: PatientProfileReview },
                { path: "medrev", name: "HcpMedReview", component: PatientMedReview },
                { path: "profilercmnd", name: "HcpProfileRec", component: PatientProfileRec },
                { path: "treatmentrcmnd", name: "HcpTreatmentRec", component: PatientTreatmentRec },
                { path: "muteduser", name: "HcpMutedUser", component: PatientMutedUser },
                { path: "receivedreviews/:type?", name: "ReceivedReviews", component: ProfileReceivedReviews },
              ],
            },
            {
              path: "nfp_administrator",
              name: "NFPProfile",
              component: DocProfile,
              children: [
                { path: "updates", name: "NFPUpdates", component: PatientUpdates },
                { path: "about", name: "NFPAbout", component: NFP_PROFILE },
                { path: "dovedaily", name: "NFPDoveDaily", component: PatientDovedaily },
                {
                  path: "circles",
                  name: "NFPCircles",
                  component: DocCircles,
                  children: [
                    {
                      path: "allCircleMembers",
                      name: "allSelfNfpCircleMembers",
                      component: AllCircleMembers,
                    },
                    {
                      path: "self",
                      name: "NFPCirlceSelf",
                      component: PatientCirlceSelf,
                    },
                    {
                      path: "other",
                      name: "NFPCircleOther",
                      component: PatientCircleOther,
                    },
                    {
                      path: "providers",
                      name: "NFPCircleProviders",
                      component: PatientCircleProviders,
                    },
                    {
                      path: "hospitals",
                      name: "NFPCircleHospitals",
                      component: PatientCircleProviders,
                    },
                    {
                      path: "clinics",
                      name: "NFPCircleClinics",
                      component: PatientCircleProviders,
                    },
                    {
                      path: "nfp",
                      name: "NFPCircleNfp",
                      component: PatientCircleProviders,
                    },
                    {
                      path: "hcp",
                      name: "NFPCircleHcp",
                      component: PatientCircleProviders,
                    },
                  ],
                },
                { path: "qa", name: "NFPQA", component: PatientQA },
                { path: "saved", name: "NFPFav", component: PatientSaved },
                { path: "polls", name: "DocPolls", component: PatientPolls },
                { path: "profilerev", name: "Nfp_adminProfileReview", component: PatientProfileReview },
                { path: "medrev", name: "Nfp_adminMedReview", component: PatientMedReview },
                { path: "profilercmnd", name: "Nfp_adminProfileRec", component: PatientProfileRec },
                { path: "treatmentrcmnd", name: "Nfp_adminTreatmentRec", component: PatientTreatmentRec },
                { path: "muteduser", name: "Nfp_adminMutedUser", component: PatientMutedUser },
              ],
            },
            {
              path: "clinic_administrator",
              name: "ClinicProfile",
              component: DocProfile,
              children: [
                {
                  path: "updates",
                  name: "ClinicUpdates",
                  component: PatientUpdates,
                },
                {
                  path: "about",
                  name: "ClinicAbout",
                  component: ClinicProfile,
                },
                {
                  path: "dovedaily",
                  name: "ClinicDoveDaily",
                  component: PatientDovedaily,
                },
                {
                  path: "circles",
                  name: "ClinicCircles",
                  component: DocCircles,
                  children: [
                    {
                      path: "allCircleMembers",
                      name: "allSelfClinicCircleMembers",
                      component: AllCircleMembers,
                    },
                    {
                      path: "self",
                      name: "ClinicCirlceSelf",
                      component: PatientCirlceSelf,
                    },
                    {
                      path: "other",
                      name: "ClinicCircleOther",
                      component: PatientCircleOther,
                    },
                    {
                      path: "providers",
                      name: "ClinicCircleProviders",
                      component: PatientCircleProviders,
                    },
                    {
                      path: "hospitals",
                      name: "ClinicCircleHospitals",
                      component: PatientCircleProviders,
                    },
                    {
                      path: "clinics",
                      name: "ClinicCircleClinics",
                      component: PatientCircleProviders,
                    },
                    {
                      path: "nfp",
                      name: "ClinicCircleNfp",
                      component: PatientCircleProviders,
                    },
                    {
                      path: "hcp",
                      name: "ClinicCircleHcp",
                      component: PatientCircleProviders,
                    },
                  ],
                },
                { path: "qa", name: "ClinicQA", component: PatientQA },
                { path: "saved", name: "ClinicFav", component: PatientSaved },
                { path: "polls", name: "DocPolls", component: PatientPolls },
                { path: "profilerev", name: "Clinic_adminProfileReview", component: PatientProfileReview },
                { path: "medrev", name: "Clinic_adminMedReview", component: PatientMedReview },
                { path: "profilercmnd", name: "Clinic_adminProfileRec", component: PatientProfileRec },
                { path: "treatmentrcmnd", name: "Clinic_adminTreatmentRec", component: PatientTreatmentRec },
                { path: "muteduser", name: "Clinic_adminMutedUser", component: PatientMutedUser },
                { path: "receivedreviews/:type?", name: "ReceivedReviews", component: ProfileReceivedReviews },
              ],
            },
            {
              path: "patient",
              name: "PatientProfile",
              component: PatientProfile,
              children: [
                {
                  path: "updates",
                  name: "PatientUpdates",
                  component: PatientUpdates,
                },
                {
                  path: "about",
                  name: "PatientAbout",
                  component: PatientAbout,
                },
                {
                  path: "dovedaily",
                  name: "PatientDovedaily",
                  component: PatientDovedaily,
                },
                {
                  path: "polls",
                  name: "PatientPolls",
                  component: PatientPolls,
                },
                {
                  path: "saved",
                  name: "PatientSaved",
                  component: PatientSaved,
                },
                {
                  path: "reviews",
                  name: "PatientReviews",
                  component: PatientReviews,
                },
                {
                  path: "circles",
                  name: "PatientCircles",
                  component: PatientCircles,
                  children: [
                    {
                      path: "allCircleMembers",
                      name: "allSelfPatientCircleMembers",
                      component: AllCircleMembers,
                    },
                    {
                      path: "self",
                      name: "patientCirlceSelf",
                      component: PatientCirlceSelf,
                    },
                    {
                      path: "other",
                      name: "patientCircleOther",
                      component: PatientCircleOther,
                    },
                    {
                      path: "providers",
                      name: "patientCircleProviders",
                      component: PatientCircleProviders,
                    },
                    {
                      path: "hospitals",
                      name: "patientCircleHospitals",
                      component: PatientCircleProviders,
                    },
                    {
                      path: "clinics",
                      name: "patientCircleClinics",
                      component: PatientCircleProviders,
                    },
                    {
                      path: "nfp",
                      name: "patientCircleNfp",
                      component: PatientCircleProviders,
                    },
                    {
                      path: "hcp",
                      name: "patientCircleHcp",
                      component: PatientCircleProviders,
                    },
                  ],
                },
                { path: "qa", name: "PatientQA", component: PatientQA },
                { path: "profilerev", name: "PatientProfileReview", component: PatientProfileReview },
                { path: "medrev", name: "PatientMedReview", component: PatientMedReview },
                { path: "profilercmnd", name: "PatientProfileRec", component: PatientProfileRec },
                { path: "treatmentrcmnd", name: "PatientTreatmentRec", component: PatientTreatmentRec },
                { path: "muteduser", name: "PatientMutedUser", component: PatientMutedUser },
                {
                  path: "treatments",
                  name: "PatientTreatments",
                  component: PatientTreatments,
                },
              ],
            },
            {
              path: "caregiver",
              name: "CaregiverProfile",
              component: PatientProfile,
              children: [
                {
                  path: "updates",
                  name: "CaregiverUpdates",
                  component: PatientUpdates,
                },
                {
                  path: "about",
                  name: "CaregiverAbout",
                  component: PatientAbout,
                },
                {
                  path: "circles",
                  name: "CaregiverCircles",
                  component: PatientCircles,
                  children: [
                    {
                      path: "allCircleMembers",
                      name: "allSelfCaregiverCircleMembers",
                      component: AllCircleMembers,
                    },
                    {
                      path: "self",
                      name: "caregiverCirlceSelf",
                      component: PatientCirlceSelf,
                    },
                    {
                      path: "other",
                      name: "caregiverCircleOther",
                      component: PatientCircleOther,
                    },
                    {
                      path: "providers",
                      name: "caregiverCircleProviders",
                      component: PatientCircleProviders,
                    },
                    {
                      path: "hospitals",
                      name: "caregiverCircleHospitals",
                      component: PatientCircleProviders,
                    },
                    {
                      path: "clinics",
                      name: "caregiverCircleClinics",
                      component: PatientCircleProviders,
                    },
                    {
                      path: "nfp",
                      name: "caregiverCircleNfp",
                      component: PatientCircleProviders,
                    },
                    {
                      path: "hcp",
                      name: "caregiverCircleHcp",
                      component: PatientCircleProviders,
                    },
                  ],
                },
                { path: "qa", name: "CaregiverQA", component: PatientQA },
                {
                  path: "saved",
                  name: "CaregiverFav",
                  component: DocFav,
                },
                {
                  path: "treatments",
                  name: "CaregiverTreatments",
                  component: PatientTreatments,
                },
              ],
            },
            {
              path: "advocate",
              name: "AdvocateProfile",
              component: AdvocateProfile,
              children: [
                {
                  path: "updates",
                  name: "AdvocateUpdates",
                  component: PatientUpdates,
                },
                {
                  path: "about",
                  name: "AdvocateAbout",
                  component: AdvocateAbout,
                },
                {
                  path: "dovedaily",
                  name: "AdvocateDoveDaily",
                  component: PatientDovedaily,
                },
                {
                  path: "circles",
                  name: "AdvocateCircles",
                  component: AdvocateCircles,
                  children: [
                    {
                      path: "allCircleMembers",
                      name: "allSelfAdvocateCircleMembers",
                      component: AllCircleMembers,
                    },
                    {
                      path: "self",
                      name: "advocateCirlceSelf",
                      component: PatientCirlceSelf,
                    },
                    {
                      path: "other",
                      name: "advocateCircleOther",
                      component: PatientCircleOther,
                    },
                    {
                      path: "providers",
                      name: "advocateCircleProviders",
                      component: PatientCircleProviders,
                    },
                    {
                      path: "hospitals",
                      name: "advocateCircleHospitals",
                      component: PatientCircleProviders,
                    },
                    {
                      path: "clinics",
                      name: "advocateCircleClinics",
                      component: PatientCircleProviders,
                    },
                    {
                      path: "nfp",
                      name: "advocateCircleNfp",
                      component: PatientCircleProviders,
                    },
                    {
                      path: "hcp",
                      name: "advocateCircleHcp",
                      component: PatientCircleProviders,
                    },
                  ],
                },
                { path: "qa", name: "AdvocateQA", component: PatientQA },
                {
                  path: "saved",
                  name: "AdvocateFav",
                  component: PatientSaved,
                },
                {
                  path: "polls",
                  name: "AdvocatePolls",
                  component: PatientPolls,
                },
                { path: "profilerev", name: "AdvocateProfileReview", component: PatientProfileReview },
                { path: "medrev", name: "AdvocateMedReview", component: PatientMedReview },
                { path: "profilercmnd", name: "AdvocateProfileRec", component: PatientProfileRec },
                { path: "treatmentrcmnd", name: "AdvocateTreatmentRec", component: PatientTreatmentRec },
                { path: "muteduser", name: "AdvocateMutedUser", component: PatientMutedUser },
              ],
            },
            {
              path: "business_administrator",
              name: "BuisnessProfile",
              component: DoctorProfile,
              children: [
                {
                  path: "updates",
                  name: "BuisnessUpdates",
                  component: PatientUpdates,
                },
                // {
                //   path: "about",
                //   name: "BuisnessAbout",
                //   component: doctor
                // },
                {
                  path: "dovedaily",
                  name: "BuisnessDoveDaily",
                  component: PatientDovedaily,
                },
                {
                  path: "circles",
                  name: "BuisnessCircles",
                  component: PatientCircles,
                  children: [
                    {
                      path: "allCircleMembers",
                      name: "allSelfBuisnessCircleMembers",
                      component: AllCircleMembers,
                    },
                    {
                      path: "self",
                      name: "BuisnessCirlceSelf",
                      component: PatientCirlceSelf,
                    },
                    {
                      path: "other",
                      name: "BuisnessCircleOther",
                      component: PatientCircleOther,
                    },
                    {
                      path: "providers",
                      name: "BuisnessCircleProviders",
                      component: PatientCircleProviders,
                    },
                    {
                      path: "hospitals",
                      name: "BuisnessCircleHospitals",
                      component: PatientCircleProviders,
                    },
                    {
                      path: "clinics",
                      name: "BuisnessCircleClinics",
                      component: PatientCircleProviders,
                    },
                    {
                      path: "nfp",
                      name: "BuisnessCircleNfp",
                      component: PatientCircleProviders,
                    },
                    {
                      path: "hcp",
                      name: "BuisnessCircleHcp",
                      component: PatientCircleProviders,
                    },
                  ],
                },
                { path: "qa", name: "BuisnessQA", component: PatientQA },
                {
                  path: "saved",
                  name: "BuisnessFav",
                  component: PatientSaved,
                },
                {
                  path: "polls",
                  name: "BuisnessPolls",
                  component: PatientPolls,
                },
                { path: "profilerev", name: "BuisnessProfileReview", component: PatientProfileReview },
                { path: "medrev", name: "BuisnessMedReview", component: PatientMedReview },
                { path: "profilercmnd", name: "BuisnessProfileRec", component: PatientProfileRec },
                { path: "treatmentrcmnd", name: "BuisnessTreatmentRec", component: PatientTreatmentRec },
                { path: "muteduser", name: "BuisnessMutedUser", component: PatientMutedUser },
              ],
            },
            // view profiles route
            {
              path: "view",
              name: "ViewProfile",
              component: ViewProfileLayout,
              children: [
                {
                  path: "doctor/:id",
                  name: "ViewDoctorProfile",
                  component: ViewDoctorProfile,
                  meta: {
                    reload: true,
                  },
                  children: [
                    {
                      path: "updates",
                      name: "ViewDoctorUpdates",
                      component: ViewPatientUpdates,
                    },
                    {
                      path: "about",
                      name: "ViewDoctorAbout",
                      component: ViewDoctorAbout,
                    },
                    {
                      path: "dovedaily",
                      name: "ViewDoctorDoveDaily",
                      component: PatientDovedaily,
                    },
                    {
                      path: "circles",
                      name: "ViewDoctorCircles",
                      component: ViewDoctorCircles,
                      children: [
                        {
                          path: "ViewAllCircle",
                          name: "viewAlldoctorCircleMembers",
                          component: ViewCircleMembersAll,
                        },
                        {
                          path: "self",
                          name: "viewdoctorCirlceSelf",
                          component: ViewCirlceSelf,
                        },
                        {
                          path: "other",
                          name: "viewdoctorCircleOther",
                          component: ViewCircleOther,
                        },
                        {
                          path: "providers",
                          name: "viewdoctorCircleProviders",
                          component: ViewCircleProviders,
                        },
                        {
                          path: "hospitals",
                          name: "viewdoctorCircleHospitals",
                          component: ViewCircleProviders,
                        },
                        {
                          path: "clinics",
                          name: "viewdoctorCircleClinics",
                          component: ViewCircleProviders,
                        },
                        {
                          path: "nfp",
                          name: "viewdoctorCircleNfp",
                          component: ViewCircleProviders,
                        },
                        {
                          path: "hcp",
                          name: "viewdoctorCircleHcp",
                          component: ViewCircleProviders,
                        },
                      ],
                    },
                    {
                      path: "qa",
                      name: "ViewDoctorQA",
                      component: ViewPatientQA,
                    },
                    {
                      path: "saved",
                      name: "ViewDoctorFav",
                      component: ViewPatientFavorites,
                    },
                    {
                      path: "polls",
                      name: "ViewDoctorProfilePolls",
                      component: ViewDoctorProfilePolls,
                    },
                    { path: "profilerev", name: "docProfileReview", component: PatientProfileReview },
                    { path: "medrev", name: "docMedReview", component: ViewPatientMedReview },
                    { path: "profilercmnd", name: "docProfileRec", component: PatientProfileRec },
                    { path: "treatmentrcmnd", name: "docTreatmentRec", component: ViewPatientTreatmentRec },
                    { path: "muteduser", name: "docMutedUser", component: PatientMutedUser },
                    { path: "receivedreviews/:type?", name: "ReceivedReviews", component: ProfileReceivedReviews },
                  ],
                },

                {
                  path: "hcp/:id",
                  name: "ViewHcpProfile",
                  component: ViewDoctorProfile,
                  children: [
                    {
                      path: "updates",
                      name: "ViewHcpUpdates",
                      component: ViewPatientUpdates,
                    },
                    {
                      path: "about",
                      name: "ViewHcpAbout",
                      component: OhcpAboutView,
                    },
                    {
                      path: "dovedaily",
                      name: "ViewHcpDoveDaily",
                      component: PatientDovedaily,
                    },
                    {
                      path: "circles",
                      name: "ViewHcpCircles",
                      component: ViewDoctorCircles,
                      children: [
                        {
                          path: "ViewAllCircle",
                          name: "viewAllhcpCircleMembers",
                          component: ViewCircleMembersAll,
                        },
                        {
                          path: "self",
                          name: "viewhcpCirlceSelf",
                          component: ViewCirlceSelf,
                        },
                        {
                          path: "other",
                          name: "viewhcpCircleOther",
                          component: ViewCircleOther,
                        },
                        {
                          path: "providers",
                          name: "viewhcpCircleProviders",
                          component: ViewCircleProviders,
                        },
                        {
                          path: "hospitals",
                          name: "viewhcpCircleHospitals",
                          component: ViewCircleProviders,
                        },
                        {
                          path: "clinics",
                          name: "viewhcpCircleClinics",
                          component: ViewCircleProviders,
                        },
                        {
                          path: "nfp",
                          name: "viewhcpCircleNfp",
                          component: ViewCircleProviders,
                        },
                        {
                          path: "hcp",
                          name: "viewhcpCircleHcp",
                          component: ViewCircleProviders,
                        },
                      ],
                    },
                    {
                      path: "qa",
                      name: "ViewHcpQA",
                      component: ViewPatientQA,
                    },
                    {
                      path: "polls",
                      name: "hcpProfilePolls",
                      component: ViewDoctorProfilePolls,
                    },
                    {
                      path: "saved",
                      name: "ViewHcpFav",
                      component: ViewPatientFavorites,
                    },
                    { path: "profilerev", name: "hcpProfileReview", component: PatientProfileReview },
                    { path: "medrev", name: "hcpMedReview", component: ViewPatientMedReview },
                    { path: "profilercmnd", name: "hcpProfileRec", component: PatientProfileRec },
                    { path: "treatmentrcmnd", name: "hcpTreatmentRec", component: ViewPatientTreatmentRec },
                    { path: "muteduser", name: "hcpMutedUser", component: PatientMutedUser },
                    { path: "receivedreviews/:type?", name: "ReceivedReviews", component: ProfileReceivedReviews },
                  ],
                },

                // view Nfp starts here

                {
                  path: "nfp/:id",
                  name: "ViewNfpProfile",
                  // component: ViewDoctorProfile,
                  component: ViewNfpProfile,
                  children: [
                    {
                      path: "updates",
                      name: "ViewNfpUpdates",
                      component: ViewPatientUpdates,
                    },
                    {
                      path: "about",
                      name: "ViewNfpAbout",
                      component: viewNfpAbout,
                    },
                    {
                      path: "dovedaily",
                      name: "ViewNfpDoveDaily",
                      component: PatientDovedaily,
                    },
                    {
                      path: "circles",
                      name: "ViewNfpCircles",
                      component: ViewDoctorCircles,
                      children: [
                        {
                          path: "ViewAllCircle",
                          name: "viewAllnfpCircleMembers",
                          component: ViewCircleMembersAll,
                        },
                        {
                          path: "self",
                          name: "viewnfpCirlceSelf",
                          component: ViewCirlceSelf,
                        },
                        {
                          path: "other",
                          name: "viewnfpCircleOther",
                          component: ViewCircleOther,
                        },
                        {
                          path: "providers",
                          name: "viewnfpCircleProviders",
                          component: ViewCircleProviders,
                        },
                        {
                          path: "hospitals",
                          name: "viewnfpCircleHospitals",
                          component: ViewCircleProviders,
                        },
                        {
                          path: "clinics",
                          name: "viewnfpCircleClinics",
                          component: ViewCircleProviders,
                        },
                        {
                          path: "nfp",
                          name: "viewnfpCircleNfp",
                          component: ViewCircleProviders,
                        },
                        {
                          path: "hcp",
                          name: "viewnfpCircleHcp",
                          component: ViewCircleProviders,
                        },
                      ],
                    },
                    {
                      path: "qa",
                      name: "ViewNfpQA",
                      component: ViewPatientQA,
                    },
                    {
                      path: "polls",
                      name: "nfpPolls",
                      component: ViewDoctorProfilePolls,
                    },
                    {
                      path: "saved",
                      name: "ViewNfpFav",
                      component: ViewPatientFavorites,
                    },
                    { path: "profilerev", name: "nfpProfileReview", component: PatientProfileReview },
                    { path: "medrev", name: "nfpMedReview", component: ViewPatientMedReview },
                    { path: "profilercmnd", name: "nfpProfileRec", component: PatientProfileRec },
                    { path: "treatmentrcmnd", name: "nfpTreatmentRec", component: ViewPatientTreatmentRec },
                    { path: "muteduser", name: "nfpPatientMutedUser", component: PatientMutedUser },
                  ],
                },

                {
                  path: "nfp_administrator/:id",
                  name: "ViewNfpAdminProfile",
                  component: ViewDoctorProfile,
                  children: [
                    {
                      path: "updates",
                      name: "ViewNfpAdminUpdates",
                      component: ViewPatientUpdates,
                    },
                    {
                      path: "about",
                      name: "ViewNfpAdminAbout",
                      component: viewNfpAbout,
                    },
                    {
                      path: "dovedaily",
                      name: "ViewNfpAdminDoveDaily",
                      component: PatientDovedaily,
                    },
                    {
                      path: "circles",
                      name: "ViewNfpAdminCircles",
                      component: ViewDoctorCircles,
                      children: [
                        {
                          path: "ViewAllCircle",
                          name: "viewAllnfp_administratorCircleMembers",
                          component: ViewCircleMembersAll,
                        },
                        {
                          path: "self",
                          name: "viewnfp_administratorCirlceSelf",
                          component: ViewCirlceSelf,
                        },
                        {
                          path: "other",
                          name: "viewnfp_administratorCircleOther",
                          component: ViewCircleOther,
                        },
                        {
                          path: "providers",
                          name: "viewnfp_administratorCircleProviders",
                          component: ViewCircleProviders,
                        },
                        {
                          path: "hospitals",
                          name: "viewnfp_administratorCircleHospitals",
                          component: ViewCircleProviders,
                        },
                        {
                          path: "clinics",
                          name: "viewnfp_administratorCircleClinics",
                          component: ViewCircleProviders,
                        },
                        {
                          path: "nfp",
                          name: "viewnfp_administratorCircleNfp",
                          component: ViewCircleProviders,
                        },
                        {
                          path: "hcp",
                          name: "viewnfp_administratorCircleHcp",
                          component: ViewCircleProviders,
                        },
                      ],
                    },
                    {
                      path: "polls",
                      name: "nfp_adminPolls",
                      component: ViewDoctorProfilePolls,
                    },
                    {
                      path: "qa",
                      name: "ViewNfpAdminQA",
                      component: ViewPatientQA,
                    },
                    {
                      path: "saved",
                      name: "ViewNfpAdminFav",
                      component: ViewPatientFavorites,
                    },
                    { path: "profilerev", name: "nfp_adminProfileReview", component: PatientProfileReview },
                    { path: "medrev", name: "nfp_adminMedReview", component: ViewPatientMedReview },
                    { path: "profilercmnd", name: "nfp_adminProfileRec", component: PatientProfileRec },
                    { path: "treatmentrcmnd", name: "nfp_adminTreatmentRec", component: ViewPatientTreatmentRec },
                    { path: "muteduser", name: "nfp_adminMutedUser", component: PatientMutedUser },
                  ],
                },

                {
                  path: "hospital_administrator/:id",
                  name: "ViewHosProfile",
                  component: ViewDoctorProfile,
                  children: [
                    {
                      path: "updates",
                      name: "ViewHos_adminUpdates",
                      component: ViewPatientUpdates,
                    },
                    {
                      path: "about",
                      name: "ViewHos_adminAbout",
                      component: ViewHospitalAbout,
                    },
                    {
                      path: "dovedaily",
                      name: "ViewHos_adminDoveDaily",
                      component: PatientDovedaily,
                    },
                    {
                      path: "circles",
                      name: "ViewHos_adminCircles",
                      component: ViewDoctorCircles,
                      children: [
                        {
                          path: "ViewAllCircle",
                          name: "viewAllhospital_administratorCircleMembers",
                          component: ViewCircleMembersAll,
                        },
                        {
                          path: "self",
                          name: "viewhospital_administratorCirlceSelf",
                          component: ViewCirlceSelf,
                        },
                        {
                          path: "other",
                          name: "viewhospital_administratorCircleOther",
                          component: ViewCircleOther,
                        },
                        {
                          path: "providers",
                          name: "viewhospital_administratorCircleProviders",
                          component: ViewCircleProviders,
                        },
                        {
                          path: "hospitals",
                          name: "viewhospital_administratorCircleHospitals",
                          component: ViewCircleProviders,
                        },
                        {
                          path: "clinics",
                          name: "viewhospital_administratorCircleClinics",
                          component: ViewCircleProviders,
                        },
                        {
                          path: "nfp",
                          name: "viewhospital_administratorCircleNfp",
                          component: ViewCircleProviders,
                        },
                        {
                          path: "hcp",
                          name: "viewhospital_administratorCircleHcp",
                          component: ViewCircleProviders,
                        },
                      ],
                    },
                    {
                      path: "polls",
                      name: "hosp_adminPolls",
                      component: ViewDoctorProfilePolls,
                    },
                    { path: "qa", name: "ViewHos_adminQA", component: ViewPatientQA },
                    {
                      path: "saved",
                      name: "ViewHos_adminFav",
                      component: ViewPatientFavorites,
                    },
                    { path: "profilerev", name: "hosp_adminProfileReview", component: PatientProfileReview },
                    { path: "medrev", name: "hosp_adminMedReview", component: ViewPatientMedReview },
                    { path: "profilercmnd", name: "hosp_adminProfileRec", component: PatientProfileRec },
                    { path: "treatmentrcmnd", name: "hosp_adminTreatmentRec", component: ViewPatientTreatmentRec },
                    { path: "muteduser", name: "hosp_adminMutedUser", component: PatientMutedUser },
                    { path: "receivedreviews/:type?", name: "ReceivedReviews", component: ProfileReceivedReviews },
                  ],
                },
                {
                  path: "clinic_administrator/:id",
                  name: "ViewClinicProfile",
                  component: ViewDoctorProfile,
                  children: [
                    {
                      path: "updates",
                      name: "ViewClinicUpdates",
                      component: ViewPatientUpdates,
                    },
                    {
                      path: "about",
                      name: "ViewClinicAbout",
                      component: ViewClinicAbout,
                    },
                    {
                      path: "dovedaily",
                      name: "ViewClinicDoveDaily",
                      component: PatientDovedaily,
                    },
                    {
                      path: "circles",
                      name: "ViewClinic_adminCircles",
                      component: ViewDoctorCircles,
                      children: [
                        {
                          path: "ViewAllCircle",
                          name: "viewAllclinic_administratorCircleMembers",
                          component: ViewCircleMembersAll,
                        },
                        {
                          path: "self",
                          name: "viewclinic_administratorCirlceSelf",
                          component: ViewCirlceSelf,
                        },
                        {
                          path: "other",
                          name: "viewclinic_administratorCircleOther",
                          component: ViewCircleOther,
                        },
                        {
                          path: "providers",
                          name: "viewclinic_administratorCircleProviders",
                          component: ViewCircleProviders,
                        },
                        {
                          path: "hospitals",
                          name: "viewclinic_administratorCircleHospitals",
                          component: ViewCircleProviders,
                        },
                        {
                          path: "clinics",
                          name: "viewclinic_administratorCircleClinics",
                          component: ViewCircleProviders,
                        },
                        {
                          path: "nfp",
                          name: "viewclinic_administratorCircleNfp",
                          component: ViewCircleProviders,
                        },
                        {
                          path: "hcp",
                          name: "viewclinic_administratorCircleHcp",
                          component: ViewCircleProviders,
                        },
                      ],
                    },
                    {
                      path: "polls",
                      name: "Clinic_adminViewPolls",
                      component: ViewDoctorProfilePolls,
                    },
                    {
                      path: "qa",
                      name: "ViewClinicQA",
                      component: ViewPatientQA,
                    },
                    {
                      path: "saved",
                      name: "ViewClinicFav",
                      component: ViewPatientFavorites,
                    },
                    { path: "profilerev", name: "clinic_adminProfileReview", component: PatientProfileReview },
                    { path: "medrev", name: "clinic_adminMedReview", component: ViewPatientMedReview },
                    { path: "profilercmnd", name: "clinic_adminProfileRec", component: PatientProfileRec },
                    { path: "treatmentrcmnd", name: "clinic_adminTreatmentRec", component: ViewPatientTreatmentRec },
                    { path: "muteduser", name: "clinic_adminMutedUser", component: PatientMutedUser },
                    { path: "receivedreviews/:type?", name: "ReceivedReviews", component: ProfileReceivedReviews },
                  ],
                },
                {
                  path: "clinic/:id",
                  name: "clinic",
                  component: HospitalViewProfile,
                  children: [
                    {
                      path: "updates",
                      name: "ClinicViewUpdate",
                      component: ViewPatientUpdates,
                    },
                    {
                      path: "about",
                      name: "ClinicViewAbout",
                      component: ViewClinicAbout,
                    },
                    {
                      path: "dovedaily",
                      name: "ClinicViewDoveDaily",
                      component: PatientDovedaily,
                    },
                    {
                      path: "circles",
                      name: "ViewClinicCircles",
                      component: ViewDoctorCircles,
                      children: [
                        {
                          path: "ViewAllCircle",
                          name: "viewAllclinicCircleMembers",
                          component: ViewCircleMembersAll,
                        },
                        {
                          path: "self",
                          name: "viewclinicCirlceSelf",
                          component: ViewCirlceSelf,
                        },
                        {
                          path: "other",
                          name: "viewclinicCircleOther",
                          component: ViewCircleOther,
                        },
                        {
                          path: "providers",
                          name: "viewclinicCircleProviders",
                          component: ViewCircleProviders,
                        },
                        {
                          path: "hospitals",
                          name: "viewclinicCircleHospitals",
                          component: ViewCircleProviders,
                        },
                        {
                          path: "clinics",
                          name: "viewclinicCircleClinics",
                          component: ViewCircleProviders,
                        },
                        {
                          path: "nfp",
                          name: "viewclinicCircleNfp",
                          component: ViewCircleProviders,
                        },
                        {
                          path: "hcp",
                          name: "viewclinicCircleHcp",
                          component: ViewCircleProviders,
                        },
                      ],
                    },
                    {
                      path: "qa",
                      name: "ClinicViewQA",
                      component: ViewPatientQA,
                    },
                    {
                      path: "favourites",
                      name: "ClinicViewFavourites",
                      component: ViewPatientFavorites,
                    },
                    {
                      path: "polls",
                      name: "ClinicViewPolls",
                      component: ViewDoctorProfilePolls,
                    },
                    { path: "profilerev", name: "clinicProfileReview", component: PatientProfileReview },
                    { path: "medrev", name: "clinicMedReview", component: ViewPatientMedReview },
                    { path: "profilercmnd", name: "clinicProfileRec", component: PatientProfileRec },
                    { path: "treatmentrcmnd", name: "clinicTreatmentRec", component: ViewPatientTreatmentRec },
                    { path: "muteduser", name: "clinicMutedUser", component: PatientMutedUser },
                    { path: "receivedreviews/:type?", name: "ReceivedReviews", component: ProfileReceivedReviews },
                  ],
                },
                {
                  path: "hospital/:id",
                  name: "hosp",
                  component: HospitalViewProfile,
                  children: [
                    {
                      path: "updates",
                      name: "HospViewUpdate",
                      component: ViewPatientUpdates,
                    },
                    {
                      path: "about",
                      name: "HospViewAbout",
                      component: ViewHospitalAbout,
                    },
                    {
                      path: "dovedaily",
                      name: "HopsViewDoveDaily",
                      component: PatientDovedaily,
                    },
                    {
                      path: "circles",
                      name: "ViewHosCircles",
                      component: ViewDoctorCircles,
                      children: [
                        {
                          path: "ViewAllCircle",
                          name: "viewAllHospCircleMembers",
                          component: ViewCircleMembersAll,
                        },
                        {
                          path: "self",
                          name: "viewHospCirlceSelf",
                          component: ViewCirlceSelf,
                        },
                        {
                          path: "other",
                          name: "viewHospCircleOther",
                          component: ViewCircleOther,
                        },
                        {
                          path: "providers",
                          name: "viewHospCircleProviders",
                          component: ViewCircleProviders,
                        },
                        {
                          path: "hospitals",
                          name: "viewHospCircleHospitals",
                          component: ViewCircleProviders,
                        },
                        {
                          path: "clinics",
                          name: "viewHospCircleClinics",
                          component: ViewCircleProviders,
                        },
                        {
                          path: "nfp",
                          name: "viewHospCircleNfp",
                          component: ViewCircleProviders,
                        },
                        {
                          path: "hcp",
                          name: "viewHospCircleHcp",
                          component: ViewCircleProviders,
                        },
                      ],
                    },
                    { path: "qa", name: "ViewHosQA", component: ViewPatientQA },
                    {
                      path: "saved",
                      name: "ViewHosFav",
                      component: ViewPatientFavorites,
                    },
                    {
                      path: "polls",
                      name: "ViewHosPolls",
                      component: ViewDoctorProfilePolls,
                    },
                    { path: "profilerev", name: "hospitalProfileReview", component: PatientProfileReview },
                    { path: "medrev", name: "hospitalMedReview", component: ViewPatientMedReview },
                    { path: "profilercmnd", name: "hospitalProfileRec", component: PatientProfileRec },
                    { path: "treatmentrcmnd", name: "hospitalTreatmentRec", component: ViewPatientTreatmentRec },
                    { path: "muteduser", name: "hospitalPatientMutedUser", component: PatientMutedUser },
                    { path: "receivedreviews/:type?", name: "ReceivedReviews", component: ProfileReceivedReviews },
                  ],
                },
                {
                  path: "patient/:id/:role?",
                  name: "ViewPatientProfile",
                  component: ViewPatientProfile,
                  children: [
                    {
                      path: "updates",
                      name: "ViewPatientUpdates",
                      component: ViewPatientUpdates,
                    },
                    {
                      path: "about",
                      name: "ViewPatientAbout",
                      component: ViewPatientAbout,
                    },
                    {
                      path: "dovedaily",
                      name: "ViewPatientDoveDaily",
                      component: ViewPatientDoveDaily,
                    },
                    {
                      path: "circles",
                      name: "ViewPatientCircles",
                      component: ViewPatientCircles,
                      children: [
                        { path: "", pathMatch: "full", redirect: "ViewAllCircle" },
                        {
                          path: "ViewAllCircle",
                          name: "viewAllpatientCircleMembers",
                          component: ViewCircleMembersAll,
                        },
                        {
                          path: "self",
                          name: "viewpatientCirlceSelf",
                          component: ViewCirlceSelf,
                        },
                        {
                          path: "other",
                          name: "viewpatientCircleOther",
                          component: ViewCircleOther,
                        },
                        {
                          path: "providers",
                          name: "viewpatientCircleProviders",
                          component: ViewCircleProviders,
                        },
                        {
                          path: "hospitals",
                          name: "viewpatientCircleHospitals",
                          component: ViewCircleProviders,
                        },
                        {
                          path: "clinics",
                          name: "viewpatientCircleClinics",
                          component: ViewCircleProviders,
                        },
                        {
                          path: "nfp",
                          name: "viewpatientCircleNfp",
                          component: ViewCircleProviders,
                        },
                        {
                          path: "hcp",
                          name: "viewpatientCircleHcp",
                          component: ViewCircleProviders,
                        },
                      ],
                    },
                    {
                      path: "qa",
                      name: "ViewPatientQA",
                      component: ViewPatientQA,
                    },
                    {
                      path: "polls",
                      name: "ViewPatientPolls",
                      component: ViewDoctorProfilePolls,
                    },
                    {
                      path: "saved",
                      name: "ViewPatientFavorites",
                      component: ViewPatientFavorites,
                    },
                    {
                      path: "treatments",
                      name: "ViewPatientTreatments",
                      component: ViewPatientTreatments,
                    },
                    { path: "profilerev", name: "viewPatientProfileReview", component: PatientProfileReview },
                    { path: "medrev", name: "viewPatientMedReview", component: ViewPatientMedReview },
                    { path: "profilercmnd", name: "viewPatientProfileRec", component: PatientProfileRec },
                    { path: "treatmentrcmnd", name: "viewPatientTreatmentRec", component: ViewPatientTreatmentRec },
                    { path: "muteduser", name: "viewPatientMutedUser", component: PatientMutedUser },
                  ],
                },
                {
                  path: "caregiver/:id",
                  name: "ViewCaregiverProfile",
                  component: ViewPatientProfile,
                  children: [
                    {
                      path: "updates",
                      name: "ViewCaregiverUpdates",
                      component: ViewPatientUpdates,
                    },
                    {
                      path: "about",
                      name: "ViewCaregiverAbout",
                      component: ViewPatientAbout,
                    },
                    {
                      path: "circles",
                      name: "ViewCaregiverCircles",
                      component: ViewPatientCircles,
                      children: [
                        {
                          path: "ViewAllCircle",
                          name: "viewAllcaregiverCircleMembers",
                          component: ViewCircleMembersAll,
                        },
                        {
                          path: "self",
                          name: "viewcaregiverCirlceSelf",
                          component: ViewCirlceSelf,
                        },
                        {
                          path: "other",
                          name: "viewcaregiverCircleOther",
                          component: ViewCircleOther,
                        },
                        {
                          path: "providers",
                          name: "viewcaregiverCircleProviders",
                          component: ViewCircleProviders,
                        },
                        {
                          path: "hospitals",
                          name: "viewcaregiverCircleHospitals",
                          component: ViewCircleProviders,
                        },
                        {
                          path: "clinics",
                          name: "viewcaregiverCircleClinics",
                          component: ViewCircleProviders,
                        },
                        {
                          path: "nfp",
                          name: "viewcaregiverCircleNfp",
                          component: ViewCircleProviders,
                        },
                        {
                          path: "hcp",
                          name: "viewcaregiverCircleHcp",
                          component: ViewCircleProviders,
                        },
                      ],
                    },
                    {
                      path: "saved",
                      name: "ViewCaregiverFav",
                      component: ViewPatientFavorites,
                    },
                    {
                      path: "treatments",
                      name: "ViewCaregiverTreatments",
                      component: ViewPatientTreatments,
                    },
                  ],
                },
                {
                  path: "advocate/:id",
                  name: "ViewAdvocateProfile",
                  component: ViewAdvocateProfile,
                  children: [
                    {
                      path: "updates",
                      name: "ViewAdvocateUpdates",
                      component: ViewPatientUpdates,
                    },
                    {
                      path: "about",
                      name: "ViewAdvocateAbout",
                      component: ViewAdvocateAbout,
                    },
                    {
                      path: "circles",
                      name: "ViewAdvocateCircles",
                      component: ViewAdvocateCircles,
                      children: [
                        {
                          path: "ViewAllCircle",
                          name: "viewAllAdvocateCircleMembers",
                          component: ViewCircleMembersAll,
                        },
                        {
                          path: "self",
                          name: "viewadvocateCirlceSelf",
                          component: ViewCirlceSelf,
                        },
                        {
                          path: "other",
                          name: "viewadvocateCircleOther",
                          component: ViewCircleOther,
                        },
                        {
                          path: "providers",
                          name: "viewadvocateCircleProviders",
                          component: ViewCircleProviders,
                        },
                        {
                          path: "hospitals",
                          name: "viewadvocateCircleHospitals",
                          component: ViewCircleProviders,
                        },
                        {
                          path: "clinics",
                          name: "viewadvocateCircleClinics",
                          component: ViewCircleProviders,
                        },
                        {
                          path: "nfp",
                          name: "viewadvocateCircleNfp",
                          component: ViewCircleProviders,
                        },
                        {
                          path: "hcp",
                          name: "viewadvocateCircleHcp",
                          component: ViewCircleProviders,
                        },
                      ],
                    },
                    {
                      path: "polls",
                      name: "ViewAdvocatePolls",
                      component: ViewDoctorProfilePolls,
                    },
                    {
                      path: "saved",
                      name: "ViewAdvocateFav",
                      component: ViewPatientFavorites,
                    },
                    {
                      path: "qa",
                      name: "ViewAdvocateQA",
                      component: ViewPatientQA,
                    },
                    { path: "profilerev", name: "viewAdvocateProfileReview", component: PatientProfileReview },
                    { path: "medrev", name: "viewAdvocateMedReview", component: ViewPatientMedReview },
                    { path: "profilercmnd", name: "viewAdvocateProfileRec", component: PatientProfileRec },
                    { path: "treatmentrcmnd", name: "viewAdvocateTreatmentRec", component: ViewPatientTreatmentRec },
                    { path: "muteduser", name: "viewAdvocateMutedUser", component: PatientMutedUser },
                  ],
                },
              ],
            },
          ],
        },

        {
          path: "account",
          name: "Account",
          component: Account,
          children: [
            { path: "activity", name: "YourActivity", component: YourActivity },
            {
              path: "settings",
              name: "AccountSettings",
              component: AccountSettings,
            },
            // {
            //   path: "notificationsettings",
            //   name: "NotificationSettings",
            //   component: NotificationSettings
            // }
          ],
        },
      ],
      beforeEnter(to, from, next) {
        window.scrollTo(0, 0)
        console.log("Scrolling...")
        if (to.matched.some(record => record.meta.requiresAuth)) {
          const user = localStorage.getItem("user")
          if (user) {
            next()
            return
          }
          next("/circles/all")
        } else {
          next()
        }
      },
      meta: {
        requiresAuth: true,
      },
    },

    // {
    //   path: "update-dovedaily",
    //   name: "UpdateDoveDaily",
    //   component: UpdateDoveDaily
    // },

    { path: "/:pathMatch(.*)*", component: PathNotFound },
  ],
})



// WEBPACK FOOTER //
// ./src/router/index.js